ApplicationAdapter = require './application'
UpdatesInterceptor = require 'mixins/updates-interceptor'

module.exports = App.DraftDishAdapter = ApplicationAdapter.extend(UpdatesInterceptor)
